// eslint-disable-next-line no-unused-vars
import React, { useMemo, useState } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { Routes, Route, Navigate } from 'react-router-dom';

import { NWTabsNavigation, NWNotification } from 'Components/shared';
import Feeds from 'Containers/APIIntegrations/Feeds';
import APIInformation from 'Containers/APIIntegrations/APIInformation';
import ECommerceTools from 'Containers/APIIntegrations/ECommerceTools';
import URLFeed from 'Components/APIIntegrations/URLFeed';
import usePermissions from 'Hooks/usePermissions';
import { PERMISSION } from 'Constants';

const StyledAPIIntegrations = styled.div``;

const APIIntegrationsComponent = () => {
  const [errors, setErrors] = useState([]);
  const theme = useTheme();
  const { t } = useTranslation();
  const { can } = usePermissions();
  const canViewUrlFeed = can(PERMISSION.ACCESS_API_INTEGRATIONS);
  const links = useMemo(
    () => [
      {
        to: 'feeds',
        label: t('profile.menu.apiFeeds')
      },
      ...(canViewUrlFeed
        ? [
            {
              to: 'url-feed',
              label: t('profile.menu.urlFeed')
            }
          ]
        : []),
      {
        to: 'api-information',
        label: t('profile.menu.apiInformation')
      },
      {
        to: 'ecommerce-tools',
        label: t('profile.menu.ecommerceTools')
      }
    ],
    [canViewUrlFeed]
  );

  return (
    <StyledAPIIntegrations theme={ theme }>
      <NWNotification delay={ 10 } errors={ errors } />
      <div className="pageTitle">
        <h3>{ t('common.pages.apiIntegrations') }</h3>
      </div>
      <NWTabsNavigation links={ links } />
      <Routes>
        <Route index element={ <Navigate to="api-information" replace /> } />
        <Route path="feeds" element={ <Feeds setErrors={ setErrors } /> } />
        { canViewUrlFeed && <Route path="url-feed" element={ <URLFeed setErrors={ setErrors } /> } /> }
        <Route path="api-information" element={ <APIInformation setErrors={ setErrors } /> } />
        <Route path="ecommerce-tools" element={ <ECommerceTools setErrors={ setErrors } /> } />
        <Route path="*" element={ <Navigate to="/not-found" replace /> } />
      </Routes>
    </StyledAPIIntegrations>
  );
};

APIIntegrationsComponent.displayName = 'APIIntegrationsComponent';

export default APIIntegrationsComponent;
